import { useTranslation } from 'react-i18next'

import { getProviderProfileOptions } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { getAsyncSelectShowSelectedApiParamIdPK } from '../../Select'
import { RequestEditUserModal } from '../RequestEditUserModal'

import {
  REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS,
  REQUEST_EDIT_PROVIDER_MODAL_QA_NAME,
} from './RequestEditProviderModal.constants'
import {
  getRequestEditProviderModalPayload,
  toSelectListItems,
} from './RequestEditProviderModal.utils'

import ProviderIcon from '../../../icons/provider.svg'

function RequestEditProviderModal({ formFieldsProps, onSubmit, ...restProps }) {
  const { t } = useTranslation()

  function handleSubmit({ values }) {
    onSubmit({ payload: getRequestEditProviderModalPayload(values), values })
  }

  return (
    <RequestEditUserModal
      {...restProps}
      containerProps={{
        qaName: REQUEST_EDIT_PROVIDER_MODAL_QA_NAME,
      }}
      formFieldsProps={{
        ...formFieldsProps,
        userFieldProps: {
          EntityIcon: ProviderIcon,
          controlProps: {
            contentProps: {
              inputProps: {
                placeholder: t('Request.EditProviderSelectPlaceholderKey'),
              },
            },
          },
          fieldComponentProps: {
            label: `${t('Request.EditProviderSelectLabelKey')}`,
          },
          getData: getProviderProfileOptions,
          getDataItems: getItemsFromIdwellApiResponse,
          getShowSelectedApiParam: getAsyncSelectShowSelectedApiParamIdPK,
          toPreparedItems: toSelectListItems,
        },
      }}
      formTitle='Modal.EditProviderTitleKey'
      userFieldName={REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditProviderModal
